var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTreatmentSummaryTimes = function SvgTreatmentSummaryTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M25 4H7v1h18zM25 27H7v1h18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M19.21 17.3c-1-.28-1.26-.91-1.26-1.3s.26-1 1.26-1.29c2.6-.71 3.62-3.65 3.62-3.65a17.1 17.1 0 0 0 1-6.06H8.22a17.1 17.1 0 0 0 1 6.06s1 2.94 3.63 3.65c1 .27 1.26.91 1.26 1.29s-.27 1-1.26 1.3c-2.61.71-3.63 3.65-3.63 3.65a17 17 0 0 0-1 6h15.56a17 17 0 0 0-1-6s-.97-2.94-3.57-3.65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M21.93 23.45c-1.15-2.8-4.07-3.32-5.17-4.55 0 0-.39-.46-.76-.46s-.76.46-.76.46c-1.1 1.23-4 1.75-5.16 4.55a4.8 4.8 0 0 0-.37 1.76.52.52 0 0 0 .48.57h11.62a.523.523 0 0 0 .48-.57 4.8 4.8 0 0 0-.36-1.76M21.33 10.97a.33.33 0 0 1 .31.49c-1.18 2.43-3.21 2.54-4.42 3.44a2 2 0 0 1-1.22.41c-.44.001-.87-.143-1.22-.41-.8-.6-2-.85-3-1.66a.42.42 0 0 1 0-.65 9.5 9.5 0 0 1 5.34-1.3 19.2 19.2 0 0 0 4.21-.32"
  })));
};
export default SvgTreatmentSummaryTimes;